import { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Banner } from 'commons/models/banner.model';
import { AppContext } from 'commons-ui';

import { UserlistData } from '../../utils/constants';
import { dehydrateFormData } from '../../utils/formDataParser';
import useService from '../../utils/useService';
import { getBannerFormDefaults } from '../../utils/formConfig';

const useCreate = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { app, showAlert } = useContext(AppContext);
	const history = useHistory();
	const { requestCreateUserSegment, requestCreateBanner } = useService();

	const createBanner = (createdData: { bannerData: Banner; userListData?: UserlistData }) => {
		setShowLoader(true);
		const { bannerData, userListData } = createdData;

		requestCreateBanner(app.appName, { ...bannerData, isGold: app.isGold, isActive: false }).then(
			(res: any) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(res?.data?.error || 'Error occured while creating the banner', { type: 'error' });
					setShowLoader(false);
					return;
				}

				if (userListData) {
					requestCreateUserSegment(app.appName, userListData).then((userRes: any) => {
						if (userRes.status !== 200 || !userRes.data.success) {
							showAlert(
								`Error: Banner was successfully created. Error occured while creating user segment. Please edit the banner to create the segment again`,
								{ type: 'error' }
							);
						} else {
							showAlert('Banner created');
						}
						setShowLoader(false);
						history.goBack();
					});
				} else {
					showAlert('Banner created');
					setShowLoader(false);
					history.goBack();
				}
			},
			(err: any) => {
				showAlert(`Error: ${err.response.data.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
	};

	const handleFormSubmit = (submittedData: any) => {
		createBanner(dehydrateFormData(submittedData));
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { data: getBannerFormDefaults(), showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useCreate;
